"use strict";
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Colours = (props) => {
  const { className, size = IconSize.Medium, color = "inherit", ...rest } = props;
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    { width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass, ...rest },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M12 21c3.418 0 6-2.597 6-5.574 0-.66-.266-1.8-.847-3.295-.558-1.438-1.333-3.02-2.175-4.494-.845-1.48-1.724-2.79-2.472-3.705-.188-.23-.358-.421-.506-.577-.148.156-.318.347-.506.577-.748.915-1.627 2.226-2.472 3.705-.842 1.473-1.617 3.056-2.175 4.494C6.267 13.626 6 14.765 6 15.426 6 18.403 8.582 21 12 21zm0 2c4.418 0 8-3.39 8-7.574C20 11.243 13.905 1 12 1c-1.905 0-8 10.243-8 14.426S7.582 23 12 23z",
        clipRule: "evenodd"
      }
    ),
    /* @__PURE__ */ React.createElement("path", { d: "M12 23c4.433-.082 8-3.445 8-7.58C20 11.345 14.11 1.527 12 1v22z", opacity: 0.6 })
  );
};
export default Colours;
